import React,{createContext,useContext,useEffect,useReducer} from "react";
import axios from "axios";
import reducer from '../reducer/productReducer'

const AppContext = createContext();
const API = "https://api.pujakaitem.com/api/products";

const initialState={
        isLoading:false,
        isError:false,
        products:[],
        featureProducts:[],
        isSingleLoading:false,
        singleProduct:{},
}

const AppProvider =({children})=>{

        const [state, dispatch] = useReducer(reducer,initialState);
     
        // here total data and feature product
    const getProducts = async(url)=>{

          dispatch({type:"SET_LOADING"})  
        try{
          const res = await axios.get(url);
          const products = await res.data;
          dispatch({type:"SET_API_DATA",payload:products })
        }
        catch(error){
                dispatch({type:"API_ERROR"})
        }
    }     

    // my 2nd api for single product
    const getSingleProduct = async(url)=>{
      dispatch({type:"SET_SINGLE_LOADING"})
      try{
        const res = await axios.get(url);
        const singleProduct = await res.data;
        dispatch({type:"SET_SINGLE_PRODUCT",payload:singleProduct});
      }
      catch(error){
        dispatch({type:"SET_SINGLE_ERROR"});
      }
    }

 useEffect(()=>{
   getProducts(API);
 },[]);

    return(
        <AppContext.Provider  value={{...state, getSingleProduct }}>
            {children}
        </AppContext.Provider>
    )
}

const useProductContext =()=>{
        return useContext(AppContext)
}
      
export {AppContext,AppProvider,useProductContext};

